// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1A60M","title":"styles_title__3Vv7N","section":"styles_section__eG--u","search":"styles_search__JkKty"};